"use strict";
/**
 * Copyright (c) Hathor Labs and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorMessages = void 0;
var ErrorMessages;
(function (ErrorMessages) {
    ErrorMessages["UNEXPECTED_PUSH_TX_ERROR"] = "unexpected-push-tx-error";
    ErrorMessages["TRANSACTION_IS_NULL"] = "transaction-is-null";
    ErrorMessages["INVALID_INPUT"] = "invalid-input";
    ErrorMessages["NO_UTXOS_AVAILABLE"] = "no-utxos-available";
    ErrorMessages["UNSUPPORTED_TX_TYPE"] = "unsupported-tx-type";
    ErrorMessages["WALLET_STATUS_ERROR"] = "wallet-status-error";
})(ErrorMessages = exports.ErrorMessages || (exports.ErrorMessages = {}));
//# sourceMappingURL=errorMessages.js.map